export default "__VITE_ASSET__rYwUa$KG__"